"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var retry_service_1 = require("./retry-service");

var ObservableRetryStrategy =
/** @class */
function () {
  function ObservableRetryStrategy() {
    this.strategy = function (options, internal) {
      return function (errorObs) {
        return errorObs.pipe(operators_1.flatMap(function (error, i) {
          var retryAttempt = i + 1;
          var statusCode = retry_service_1.retryService.getStatusCodeFromError(error);
          var retryAfter = retry_service_1.retryService.tryGetRetryAfterInMsFromError(error);

          if (!retry_service_1.retryService.canRetryStatusCode(statusCode, options.useRetryForResponseCodes)) {
            // request with given status code cannot be retried
            return rxjs_1.throwError(error);
          }

          if (!retry_service_1.retryService.canRetry(internal.startTime, options.maxCumulativeWaitTimeMs)) {
            // request should not be retried anymore
            return rxjs_1.throwError(error);
          } // get wait time


          var waitTime = retry_service_1.retryService.getNextWaitTimeMs(options.addJitter, options.deltaBackoffMs, retryAttempt, retryAfter); // debug log attempt

          retry_service_1.retryService.debugLogAttempt(retryAttempt, waitTime);
          return rxjs_1.timer(waitTime);
        }));
      };
    };
  }

  return ObservableRetryStrategy;
}();

exports.ObservableRetryStrategy = ObservableRetryStrategy;
exports.observableRetryStrategy = new ObservableRetryStrategy();